/**
* @summary - Component that Provides Create item details functionality
* @autor vengateshwaran k
* @since 2024-05-30
*/
import {
    Box,
    Checkbox,
    FormControl,
    FormControlLabel,
    FormGroup,
    Grid,
    Typography
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import itemDetailsRepository from '../../api/repositories/itemDetailsRepository';
import { BreadcrumbBar } from "../../assets/styled-components/breadcrumbBar";
import { DefaultCard } from "../../assets/styled-components/card";
import PageTittle from '../../components/commoncomponents/PageTitle';
import { BemsGraph, FemsGraph } from "../../utility/apiURLS";
import commonMessages from '../../utility/constant';
import { getAuthToken, getFacilityId } from "../../utility/tokenUtility";
import CustomDialog from "../commoncomponents/CustomDialog";
import CustomFooter from "../commoncomponents/CustomFooter";
import CustomMultiSelect from '../commoncomponents/CustomMultiSelect';
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import CustomTextField from "../commoncomponents/CustomTextField";
import CustomTextFieldWithSearch from "../commoncomponents/CustomTextFieldWithSearch";
import Tooltip from '@mui/material/Tooltip';
const CreateItemDetails = () => {
    const navigate = useNavigate();
    const itemDetailsFromList = useLocation();
    const { state } = itemDetailsFromList;
    const [itemCode, setItemCode] = useState();
    const [itemDescription, setItemDescription] = useState();
    const [itemType, setItemType] = useState();
    const [itemTypeOptions, setItemTypeOptions] = useState([]);
    const [workGroupOptions, setWorkGroupOptions] = useState([]);
    const serviceOptions = [
        { label: "BEMS", Id: 1, value: "BEMS" }, { label: "FEMS-Elec", id: 2, value: "FEMS-Elec" },
        { label: "FEMS-Mec", Id: 3, value: "FEMS-Mec" }, { label: "FEMS-Civil", id: 4, value: "FEMS-Civil" }
    ];
    const [service, setService] = useState();
    const [brand, setBrand] = useState();
    const statusOptions = [{ label: "Active", Id: 1, value: true, default: true }, { label: "In Active", id: 2, value: false, default: false }];
    const [status, setStatus] = useState(statusOptions?.find((item) => item?.default === true));
    const [store, setStore] = useState();
    const [storeOptions, setStoreOptions] = useState([]);
    const [errors, setErrors] = useState({});
    const [openValidationDialog, setOpenValidationDialog] = useState(false);
    const [saveConfirmDialogue, setSaveConfirmDialogue] = useState(false);
    const facilityId = getFacilityId();
    const [dialogContent, setDialogContent] = useState('');
    const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [isView, setIsView] = useState(false);
    const [isAddNew, setIsAddNew] = useState(false);
    const [errorMessages, setErrorMessages] = useState({});
    const [readOnly, setReadOnly] = useState(false);
    const [isChanged, setIsChanged] = useState(false);
    const [changedCount,setChangedCount]= useState(0);
    const [minimumStock, setMinimumStock] = useState();
    const [maximumStock, setMaximumStock] = useState();
    const [unitCost, setUnitCost] = useState();
    // const [isReceivedAllData.current, isReceivedAllData.current] = useState(false);
    const [selectedServices, setSelectedServices] = useState([]);
    const [workGroup, setWorkGroup] = useState([]);
    const itemCodeRef = useRef(null);
    const itemDescriptionRef = useRef(null);
    const [responseWorkgroupArray, setResponseWorkgroupArray] = useState([]);
    const [isDuplicate, setIsDuplicate] = useState(false)
    const [rows, setRows] = useState([]);
    const [rowList, setRowList] = useState([]);
    const[isItemCodeDuplicate,setIsItemCodeDuplicate]=useState();
    const [viewWorkGroup,setViewWorkGroup]=useState();
    const isReceivedAllData= useRef(false);
    useEffect(() => {
        fetchFieldData();
    }, [])

    useEffect(() => {
        if (isEdit) {
            itemDescriptionRef?.current.focus();
        } else {
            itemCodeRef?.current.focus();
        }
    }, [isEdit]);

    const fetchItemDetails = async () => {
        try {
            const formattedData = await itemDetailsRepository.fetchExportdata(facilityId);
            setRowList(formattedData?.data?.items);
        } catch (error) {
            console.error("Error fetching data", error);
        }
    };
    const fetchOptions = async () => {
        try {
            const token = getAuthToken("id_token");
            const facilityId = getFacilityId();
            const config = {
                headers: { Authorization: `Bearer ${token}` },
            };

            const [workGroupBems, workGroupFems] = await Promise.all([
                await axios.get(
                    `${BemsGraph}/api/GraphWorkGroupDetails/GetWorkGroupDetailsByFacilityId/${facilityId}?size=100`,
                    config
                ),
                await axios.get(
                    `${FemsGraph}/api/GraphWorkGroupDetails/GetWorkGroupDetailsByFacilityId/${facilityId}?size=100`,
                    config
                ),
            ]);
            const workGroupResponse = [
                ...workGroupFems.data.map((data) => {
                    return {
                        label: `${data.wgcode}-${data.wgdesc}`,
                        value: `${data.wgcode}-${data.wgdesc}`,
                        id: data.id,
                        service: "FEMS-Elec",
                    };
                }), ...workGroupFems.data.map((data) => {
                    return {
                        label: `${data.wgcode}-${data.wgdesc}`,
                        value: `${data.wgcode}-${data.wgdesc}`,
                        id: data.id,
                        service: "FEMS-Mec",
                    };
                }), ...workGroupFems.data.map((data) => {
                    return {
                        label: `${data.wgcode}-${data.wgdesc}`,
                        value: `${data.wgcode}-${data.wgdesc}`,
                        id: data.id,
                        service: "FEMS-Civil",
                    };
                }),
                ...workGroupBems.data.map((data) => {
                    return {
                        label: `${data.wgcode}-${data.wgdesc}`,
                        value: `${data.wgcode}-${data.wgdesc}`,
                        id: data.id,
                        service: "BEMS",
                    };
                }),
            ];
            setResponseWorkgroupArray(workGroupResponse);
        } catch (error) {
            console.error("Error fetching options:", error);
        }
    };
    const handleItemDescription = (newValue) => {
        setItemDescription(newValue);
        setIsChanged(true);
        if (newValue.startsWith(' ')) { 
           setErrors({ ...errors, itemDescription: 'Invalid Input. Only letters, spaces, and the characters ,-!@#$%&*()_- are allowed.' });
    } 
    // else if (newValue.includes('  ')) {
    //         setErrors({ ...errors, itemDescription: 'Invalid Input. Only letters, spaces, and the characters ,-!@#$%&*()_- are allowed.' });
    //     } 
        else if (/[^a-zA-Z ,!@#$%&*()_-]/.test(newValue)) {
            setErrors({ ...errors, itemDescription: 'Invalid Input. Only letters, spaces, and the characters ,-!@#$%&*()_- are allowed.' });
        } else {
            setErrors({ ...errors, itemDescription: null })
        }
    };


    const handleBrandChange = (newValue) => {

        setBrand(newValue);
        setIsChanged(true);

        if (newValue.startsWith(' ')) { 
           setErrors({ ...errors, brand: 'Invalid Input. Only letters, spaces, and the characters ,-!@#$%&*()_- are allowed.' });
    } 
    // else if (newValue.includes('  ')) {
    //         setErrors({ ...errors, brand: 'Invalid Input. Only letters, numbers, spaces, and the characters ,-!@#$%&*()_- are allowed.' });
    //     }
         else if (/[^a-zA-Z ,!@#$%&*()_-]/.test(newValue)) {
            setErrors({ ...errors, brand: 'Invalid Input. Only letters, spaces, and the characters ,-!@#$%&*()_- are allowed.' });
        } else {
            setErrors({ ...errors, brand: null })
        }
    };
    const fetchFieldData = async () => {
        try {
            const formattedData = await itemDetailsRepository.getItemDetailsList(facilityId);
            setRows(formattedData?.data);
            const typeCode = await itemDetailsRepository.getItemType();
            setItemTypeOptions(typeCode);
            const getStoreOptions = await itemDetailsRepository.getStore(facilityId);

            setStoreOptions(getStoreOptions);
           // setStoreOptions(getStoreOptions);
            const workgroup = await fetchOptions();

            const RowLists = await itemDetailsRepository.getItemDetailsList(facilityId);
            setRowList(RowLists?.data?.items);
            isReceivedAllData.current=true;
        }
        catch (e) {
            console.log(e);
        }

    }

    const handleCancel = () => {
        if(isView){
            navigate(-1, { replace: true });
        }
        else if (isChanged && isEdit) {
            setCancelDialogOpen(true)
            setDialogContent("Record(s) not Saved/Updated. Do you want to continue?")
         
        }
        else {
            navigate(-1, { replace: true });        
        }

    }

    useEffect(() => {
        const filteredWorkGroupOptions = (responseWorkgroupArray) => {
            // Filter the array to only include objects with a `service` in `selectedServices`
            const filteredArray = responseWorkgroupArray?.filter(option =>
                selectedServices?.includes(option.service)
            );

            // Use a Set to keep track of services we have already seen
            const uniqueServices = new Set();

            // Filter out duplicates
            const uniqueFilteredArray = filteredArray?.filter(option => {
                const isDuplicate = uniqueServices.has(option.value);
                uniqueServices.add(option.value);
                return !isDuplicate;
            });

            // Set the unique filtered options
            return uniqueFilteredArray;
        };

        const updatedWorkGroupOptions = filteredWorkGroupOptions(responseWorkgroupArray);
        // Assuming you have a setter function to update the state
        setWorkGroupOptions(updatedWorkGroupOptions); // Replace with your actual state setter
    }, [selectedServices]);
const getWorkgroup=async()=>{
    const selectedWorkGoupsList = state?.workGroup?.split(',')
    let value=workGroupOptions?.filter((option) => selectedWorkGoupsList?.includes(option.value));
    return value;
}

    const setEditWorkGroupOptions = useMemo(async() => {
        if (isEdit && !!workGroupOptions) {
            const selectedWorkGroups=await getWorkgroup();        
            setWorkGroup(selectedWorkGroups);
        }else if(isView){
            setViewWorkGroup(state?.workGroup);
        }
    }, [workGroupOptions]);

    const handleDialogClose = () => {
        setCancelDialogOpen(false);
        setOpenValidationDialog(false);
        setIsChanged(false);
    };
    const handleSaveDialogClose = () => {
        setOpenValidationDialog(false);
        setIsChanged(false);
    };

    const handleCancelDialogClose = () => {
        setCancelDialogOpen(false);

    };

    const setDefault = () => {

        setItemCode('');
        setItemDescription('');
        setItemType();
        setService('');
        setWorkGroup([]);
        setBrand('');
        setMinimumStock('');
        setMaximumStock('');
        setUnitCost('')
        setIsChanged(false)
        setIsAddNew(false)
        setErrors({})
        setErrorMessages({})
        setStatus(statusOptions?.find((item)=>item?.default===true));
        setStore({label:'',value:''})
        setSelectedServices('')
        //  isFutureDate('')

    };
    const handleAddNew = () => {
        if (isChanged) {
            setIsAddNew(true);
            setCancelDialogOpen(true);
            setDialogContent("Record(s) not Saved/Updated. Do you want to continue?");
        } else {
            setDefault();
        }
    };
    const handleConfirmCancel = () => {
        setCancelDialogOpen(false)
        setOpenValidationDialog(false)
        if (isAddNew) {
            setDefault()
        }

        if (isChanged && !isAddNew && !openValidationDialog) {
            setCancelDialogOpen(false);
            navigate(-1, { replace: true });
        }

    };
    const handleConfirmSave = () => {
        setIsDuplicate(false);
        setCancelDialogOpen(false)
        setOpenValidationDialog(false)
        setSaveConfirmDialogue(false);
        navigate(-1, { replace: true });
    };
    //updating 
    const stateChange = useMemo(() => {
        if (itemDetailsFromList.state && isReceivedAllData.current === true) {

            setItemCode(state.itemCode);
            setItemDescription(state.itemDescriptionname);
            itemTypeOptions?.status != "error" && itemTypeOptions?.forEach((item) => {
                if (item?.id === state?.itemTypeId) {
                    setItemType({ ...item });
                }
            })
            storeOptions?.status != "error" && storeOptions?.forEach((item) => {
                if (item?.warehousecode === state?.store) {
                    setStore({ ...item })
                }
            })
            statusOptions?.status != "error" && statusOptions?.forEach((item) => {
                if (state?.isactive === item?.value) {
                    setStatus({ ...item });
                }
            })
            setBrand(state.compitembrand);
            setMinimumStock(state.minimumStock);
            setMaximumStock(state.maximumStock);
            setUnitCost(state.unitCost);
            setIsView(state.isViewMode);
            setIsEdit(state.isEditMode);
            setSelectedServices(state?.service?.split(",") || '');

        } else {
            setIsEdit(false);
            setIsView(false);
        }
    }, [isReceivedAllData.current===true]);

    const handleServiceChange = (event) => {
        setIsChanged(true);
      
        const { value, checked } = event.target;
        if (checked) {
            setErrors((prev) => ({ ...prev, services: false }));
            setErrorMessages((prev) => ({ ...prev, services: "" }));
        }
        setSelectedServices((prev) =>
            checked ? [...prev, value] : prev?.filter((service) => service !== value)
        );
    };
    const validateTextFieldCode = (text) => {
        const pattern = /^(?! )[a-zA-Z0-9/-]+(?: [a-zA-Z0-9/-]+)* ?$/;
        return pattern.test(text);
    };


    const handleItemCode = (newValue) => {

        setItemCode(newValue);
        setIsChanged(true);
        if (newValue.startsWith(' ')) {
            setErrors({ ...errors, itemCode: 'Invalid input. Only letters, numbers, /, and - are allowed.' })}
             else if (/[^a-zA-Z0-9\/ -]/.test(newValue)) {
            setErrors({ ...errors, itemCode: 'Invalid input. Only letters, numbers, /, and - are allowed.' })
        } else {
            setErrors({ ...errors, itemCode: null })
        }
    };



    const handleSave = async () => {
        try {
      const timestamp = "AAAAAAABJKk="; // Add timestamp for sorting

            let itemCodeCheck = validateTextFieldCode(itemCode);
            const newErrors = {};
            if (!itemCode || !itemCodeCheck) newErrors.itemCode = !itemCode ? "Item Code is required":'Invalid input. Only letters, numbers, /, and - are allowed.' ;
            if (!brand) newErrors.brand = "Brand/Make is required";
            if (!itemDescription) newErrors.itemDescription = "Item Description is required";
            if (itemType==null) newErrors.itemType = "Item Type is required";
            if (status==null) newErrors.status = "Status is required";
            if (!store?.label) newErrors.store = "Store is required";
            let duplicate=rowList?.filter((item)=>{
                if(item?.itemcode===itemCode){
                return item;
            }
            })
            if (Object.keys(newErrors).length > 0 || !isChanged || (duplicate?.length > 0 && !isEdit)) {
               if(Object.keys(newErrors).length > 0){
                setErrors(newErrors);
               }else if((!isChanged && !isEdit) || (duplicate?.length > 0 && !isEdit)){
                setIsDuplicate(true);
                setSaveConfirmDialogue(true);
               }else if((!isChanged && isEdit)){
                setIsDuplicate(true);
                setSaveConfirmDialogue(true);
               }
            } else {
                // Common data for both create and update operations
                let item = {
                    "facilityid": state?.facilityId,
                    "itemcode": itemCode,
                    "descriptionname": itemDescription,
                    "masimsitemtype": { ...itemType, ItemType: itemType?.label },
                    "itemservice": selectedServices ? selectedServices?.join(",") : '',
                    "workgroup": workGroup?.map(obj => obj.value)?.join(',') || '',
                    "isactive": status?.value, //status
                    "masimswarehousedetails": { ...store, Warehousedesc: store?.label },
                    "compitembrand": brand,
                    "minimumstock": minimumStock || 0,
                    "maximumstock": maximumStock || 0,
                    "unitcost": unitCost || 0,
                    "masimsstockregisters": [],
                    "isdeleted": false,


                };

                if (!isEdit && isChanged) {
                    if (!isDuplicate) {
                        const createResponse = await itemDetailsRepository.createItemDetails(item);
                        if (createResponse?.status <= 204) {
                            setSaveConfirmDialogue(true);
                            setIsChanged(false);
                            setChangedCount(0);
                            fetchItemDetails();
                        }
                    } else {
                        setSaveConfirmDialogue(true);
                    }
                } else if (isChanged) {
                    const Id = state?.itemcodeId;
                    if (!isDuplicate) {
                        let itemValue={...item,timestamp}
                        const response = await itemDetailsRepository.updateItemDetails(itemValue, Id);
                        if (response?.status <= 204) {
                            setSaveConfirmDialogue(true);
                            setIsChanged(false);
                            setChangedCount(0);
                            fetchItemDetails();
                        }
                    } else {
                        setSaveConfirmDialogue(true);
                    }

                }else{
                    setIsDuplicate(true);
                    setSaveConfirmDialogue(true);
                }


            }
        } catch (error) {
            console.error("Login error:", error);
            if (error.response && error.response.status === 401) {
                console.log(error.response);
            } else {
                console.log("data not inserted properly");
            }
        }
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        let formIsValid = true;
        // If form is valid, proceed with saving
        if (formIsValid) {
            handleSave();
        }
    };

    return (
        <>
            <BreadcrumbBar>
                <Box sx={{ display: "inline-flex", gap: 1.25, alignItems: "center" }}>


                    <PageTittle title={isEdit ? "Edit Item Details" : isView ? "View Item Details" : "Create Item Details"} />


                </Box>

            </BreadcrumbBar>
            <Box mt={{ xs: 1, md: 2 }}>
                <DefaultCard sx={{ height: "100%" }}>
                    <form onSubmit={handleSubmit} style={{ position: "relative" }}>
                        <Box mb={2}>
                            <Grid container spacing={2}>



                                <Grid item xs={6} md={4}>
                                    <CustomTextField
                                        label="Item Code"
                                        id="itemcode"
                                        value={itemCode}
                                        onChange={handleItemCode}
                                        disabled={isView || isEdit}
                                        isMandatoryField={true}
                                        readOnly={readOnly || isView}
                                        error={errors.itemCode}
                                        errorMessage={errors.itemCode}
                                        maxlength={16}
                                        inputRef={itemCodeRef}
                                        checkDuplicate={true}
                                        valueForCheckDuplicate={state?.itemLists ? state?.itemLists : []}
                                        isDuplicate={(item) => setIsDuplicate(item)}
                                    />
                                </Grid>
                                <Grid item xs={6} md={4}>
                                    <CustomTextField
                                        label="Item Description"
                                        id="itemdescription"
                                        value={itemDescription}
                                        maxlength={120}
                                        isMandatoryField={true}
                                        error={errors.itemDescription}
                                        errorMessage={errors.itemDescription}
                                        onChange={handleItemDescription}
                                        disabled={isView}
                                        inputRef={itemDescriptionRef}
                                    />
                                </Grid>
                                <Grid item xs={6} md={4}>
                                    <CustomSelectInput
                                        isMandatoryField={true}
                                        error={!!errors?.itemType}
                                        errorMessage={errors.itemType}
                                        disabled={isView}
                                        label="Item Type"
                                        id="itemtype"
                                        value={itemType}
                                        options={itemTypeOptions?.status != "error" ? itemTypeOptions : []}
                                        onChange={(newValue) => {
                                            setItemType(newValue);
                                            setIsChanged(true);                                          
                                            setErrors({ ...errors, itemType: null })
                                        }
                                        }
                                    />
                                </Grid>

                                <Grid item xs={6} md={4}>
                                    <FormControl fullWidth error={true}>
                                        <Box>
                                            <Typography variant="labelSm">Service</Typography>
                                  
                                        </Box>
                                 
                                        <FormGroup row sx={{ justifyContent: "space-between" }}>
                                            {serviceOptions.map((service) => (
                                                <FormControlLabel
                                                    key={service.value}
                                                    control={
                                                        <Checkbox
                                                            error={true}
                                                            checked={selectedServices?.includes(service.value)}
                                                            onChange={handleServiceChange}
                                                            value={service.value}
                                                            disabled={isView}
                                                        />
                                                    }
                                                    label={service.label}
                                                />
                                            ))}
                                        </FormGroup>
                                    </FormControl>
                                </Grid>
                       
                               
                                   {!isView ?  <Grid item xs={6} md={4}><CustomMultiSelect
                                        label="Work Group"
                                        values={workGroup}
                                        disabled={isView}
                                        options={workGroupOptions}
                                        onChange={(newValue) => {
                                            setWorkGroup(newValue);                                           
                                            if(newValue?.length>0){
                                                setIsChanged(true);                                              
                                            setChangedCount(changedCount+1)
                                            }
                                        }}
                                        isMandatoryField={false}
                                        error={errors.workGroups}
                                        helperText={errorMessages.workGroups}
                                    /> </Grid>:  
                                        <Grid item xs={6} md={8}> <CustomTextField                                    
                                    label="Work Group"
                                    id="workgroup"
                                    value={viewWorkGroup}
                                    isMandatoryField={false}
                                    isRefilByOtherField={false}
                                    disabled={isView}
                                    maxlength={256}
                                    multiLine={true}

                                /></Grid>}
                                
                                <Grid item xs={6} md={4}>
                                    <CustomSelectInput
                                        id="status"
                                        label="Status"
                                        value={status}
                                        error={!!errors?.status}
                                        errorMessage={errors.status}
                                        options={statusOptions}
                                        onChange={(newValue) => {
                                                setStatus(newValue);
                                                setIsChanged(true);  
                                            setErrors({ ...errors, status: null });

                                        
                                        }}
                                        disabled={isView}
                                        isMandatoryField={true}
                                    />
                                </Grid>
                                <Grid item xs={6} md={4}>
                                    <CustomTextFieldWithSearch
                                        isMandatoryField={true}
                                        label="Store"
                                        id="store"
                                        error={!!errors?.store}
                                        disabled={isView}
                                        errorMessage={errors.store}
                                        value={store}
                                        options={storeOptions?.map((item)=>{
                                            return{...item,
                                                label:`${item?.warehousecode}-${item?.label}`
                                            }

                                        })?.sort((a, b) => a.label.localeCompare(b.label))}
                                        onChange={(newValue) => {
                                            if(newValue?.label!=''){
                                                setIsChanged(true);  
                                            }
                                            setStore({...newValue,label:newValue?.value});                             
                                            setErrors({ ...errors, store: null })
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={6} md={4}>
                                    <CustomTextField
                                        isMandatoryField={true}
                                        label="Brand/Make"
                                        id="brand"
                                        value={brand}
                                        onChange={handleBrandChange}
                                        isRefilByOtherField={false}
                                        disabled={isView}
                                        error={!!errors?.brand}
                                        errorMessage={errors.brand}
                                        maxlength={60}

                                    />
                                </Grid>

                                <Grid item xs={6} md={4}>
                                    <CustomTextField
                                        label="Minimum Stock"
                                        id="minimumstock"
                                        value={minimumStock}
                                        disabled={isView}
                                        isMandatoryField={false}
                                        isRefilByOtherField={false}
                                        onlyNumbers={true}
                                        onChange={(newValue) => {
                                            setMinimumStock(newValue);
                                            setIsChanged(true);
                                          
                                        }}
                                        textAlign="right"
                                    />
                                </Grid>
                                <Grid item xs={6} md={4}>
                                    <CustomTextField
                                        label="Maximum Stock"
                                        id="maximumstock"
                                        value={maximumStock}
                                        disabled={isView}
                                        isMandatoryField={false}
                                        isRefilByOtherField={false}
                                        onlyNumbers={true}
                                        onChange={(newValue) => {
                                            setIsChanged(true);
                                          
                                            setMaximumStock(newValue);
                                        }}
                                        textAlign="right"
                                    />
                                </Grid>
                                <Grid item xs={6} md={4}>
                                    <CustomTextField
                                        label="Unit Cost"
                                        id="unitcost"
                                        value={unitCost}
                                        allowDecimal={true}
                                        disabled={isView}
                                        isMandatoryField={false}
                                        isRefilByOtherField={false}
                                        onChange={(newValue) => {
                                            setUnitCost(newValue);
                                            setIsChanged(true);
                                          
                                        }}
                                        textAlign="right"
                                    />
                                </Grid>


                            </Grid>
                        </Box>
                    </form>

                    <Box
                        sx={{
                            display: "flex",
                            gap: 2,
                            justifyContent: { xs: "center", md: "end" },
                        }}
                    >


                        <CustomFooter
                            cancelClick={handleCancel}
                            saveClick={handleSubmit}
                            addClick={handleAddNew}
                            readOnly={isView}
                            buttonLabel={isEdit ? "Update" : "Save"}
                            isEdit={isEdit}
                            showAddButton={true}
                        />

                    </Box>
                </DefaultCard>
            </Box>
            <CustomDialog
                open={openValidationDialog}
                onConfirm={handleConfirmCancel}
                onClose={handleDialogClose}
                content={dialogContent}
                confirmBtn={'Ok'}
            />
            <CustomDialog
                open={saveConfirmDialogue}
                onConfirm={handleConfirmSave}
                onClose={handleSaveDialogClose}
                content={(isEdit) ? commonMessages.updateSuccessMessage : !isDuplicate ? commonMessages.saveSuccessmessage : "Item Code already exists."}
                confirmBtn={'Ok'}
            />

            <CustomDialog
                open={cancelDialogOpen}
                onClose={handleCancelDialogClose}
                onConfirm={handleConfirmCancel}
                content={dialogContent}
                confirmBtn={'Yes'}
                cancelBtn={'No'}
            />
        </>
    );
};

export default CreateItemDetails;
